import template from './_form.pug'
import copyTextFromElementById from 'js/services/copy-text-from-input.js'

const Fields = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  password: '',
  accountId: '',
  logo: ''
}

export default Vue.extend({
  template: template(),
  props: {
    initData: {
      type: Object,
      default: null
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    saveButtonText: {
      type: String,
      default: () => Vue.i18n.t('general.save')
    }
  },
  data() {
    return {
      data: {},
      accountsOptions: [],
      removeAvatar: false,
      whitelist: ['jpg', 'png', 'jpeg'],
      accounts: [] 
    }
  },
  computed: {
    modeForm() {
      return this.data.id ? 'edit' : 'new'
    },
    isEditing() {
      return this.modeForm === 'edit'
    },
    showInitials() {
      return (!this.initData?.logoUrl && !this.data.logo) || this.removeAvatar
    }
  },
  watch: {
    initData: {
      immediate: true,
      handler() {
        this.initializeData()
      }
    }
  },
  created() {
    this.loadAccounts()
  },
  methods: {
    loadAccounts() {  
      
      API.laiaAccounts.index({page: {number: 1, size: 1000}}).then(({data, meta}) => {
        this.accountsOptions = data.map(customer => ({
          label: customer.name,
          value: customer.id
        }))
      })
    },
    initializeData() {
      this.data = { ...Fields, ...(this.initData || {}) }
    },
    t(key, options = {}) {
      return this.$t(`superAdmins.form.${key}`, options)
    },
    submit() {
      this.$emit('submit', this.data)
    },
    cancel() {
      this.$emit('cancel')
    },
    logoChanged(file) {
      this.removeAvatar = !file
    },
    errorUpload(errors = []) {
      const error = errors.includes('invalidFileType') ? 'invalidFileType' : errors[0]
      if (error) {
        this.$notifications.error(this.t(`fields.logo.errors.${error}`))
      }
    },
    openLogoInput() {
      this.$refs.logoInput.$el.children[0].click()
    },
    generatePassword() {
      const length = 12
      const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()-_"
      let password = ""

      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length)
        password += charset[randomIndex]
      }

      this.data.password = password
    },
    copyPassword(domId) {
      if (copyTextFromElementById(domId)) {
        this.$notifications.success(this.t('succesfullyCopied'))
      } else {
        this.$notifications.error(this.t('errorOnCopy'))
      }
    }
  }
})
